import { Grid, IconButton, withStyles } from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import AsterTitleTypography from 'asterX-UIkit/Typography/AsterTitleTypography'

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    paddingLeft: '12px'
  },
  closeButton: {
    color: theme.palette.grey[500]
  }
})

const DialogTitleCustom = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <AsterTitleTypography label={children} />
      {onClose ? (
        <Grid item>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      ) : null}
    </MuiDialogTitle>
  )
})
export default DialogTitleCustom
